export default __webpack_public_path__ + "static/media/rbclogo.8bed12c3.png";